// src/pages/EventsDetails.js
import React from "react";
import FeatureDetailPage from "./FeatureDetailPage";
import { PartyPopper } from "lucide-react";
import eventsIllustration from "./assets/events-illustration.svg";

const EventsDetails = () => {
  return (
    <FeatureDetailPage
      icon={<PartyPopper size={32} className="text-purple-400" />}
      title="Personal Events"
      description="Become the master planner. Create your own personal events, from birthday parties to weekend trips, and send invites directly to your friends and family's mobile numbers."
      imageSrc={eventsIllustration}
      benefits={[
        "Design custom events with unique details and descriptions.",
        "Create custom RSVP forms to gather all the info you need.",
        "Invite anyone with a mobile number, even if they aren't on TimeWise yet.",
        "Manage your social calendar alongside your professional one.",
      ]}
    />
  );
};

export default EventsDetails;
